import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TranslationKey } from '../../i18n/translationKeys';
import { PageTitle } from '../../ui/PageTitle/PageTitle';
import { NoSectionAccess } from '../../components/NoSectionAccess/NoSectionAccess';
import { useTasksStore } from '../../stores/tasksStore';
import { HistoryTimeline } from './HistoryTimeline';

export const HistoryList: React.FC = () => {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const customerId = searchParams.get('customerId') ?? undefined;

    // Historique shares its access right with Relance client (same CUSTOMER_RELANCE event stream) —
    // persisted backend decision, not a live bridge read (see TenantSectionAccessEntity). Fails open
    // (true) while dailyTasks hasn't loaded yet — e.g. a direct /history visit before Header's fetch
    // resolves — consistent with "unknown ≠ denied" elsewhere in the app. The header button is gated
    // on the same flag, but a direct URL visit bypasses it, hence this in-page guard.
    const relanceAccessible = useTasksStore(s => s.dailyTasks?.relanceAccessible ?? true);

    return (
        <div className="flex flex-col gap-2xl">
            <PageTitle>{t(TranslationKey.History.Title)}</PageTitle>
            {relanceAccessible ? (
                <HistoryTimeline customerId={customerId} />
            ) : (
                <NoSectionAccess
                    testId="history-no-access"
                    title={t(TranslationKey.History.AccessDenied.Title)}
                    message={t(TranslationKey.History.AccessDenied.Message)}
                />
            )}
        </div>
    );
};
